<template>
  <div class="header">
    <div class="header_center">
      <div class="header_left">
        <img class="logo" src="@/assets/image/login/login_logo.webp" style="cursor: pointer;" alt="" srcset="" @click="$router.push('/')" />
        <Menu style="margin-left: 50px" />
      </div>
      <div class="header_right">
        <userMenu />
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import userMenu from "./userMenu.vue";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  components: {
    Menu,
    userMenu,
  },
  name: "defHeader",
  data() {
    return {};
  },
  mounted() {},
  computed: {
    ...mapState("user", ["user"]),
    center1200() {
      return this.$route.meta.center1200;
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@use "@/assets/styles/index.scss" as *;

.header {
  width: 100%;
  min-width: 1000px;
  height: 64px;
  display: flex;
  justify-content: center;
  // position: sticky;
  top: 0;
  z-index: 10;
  padding: 0 24px;
  position: relative;
  &_center {
    width: 100%;
    // max-width: $container-w;
    height: 100%;
    // padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // padding-left: 24px;
    // padding-right: 24px;
    min-width: 600px;
    box-sizing: border-box;

    // @media (min-width: 1248px) {
    //   padding-left: 0;
    //   padding-right: 0;
    // }
    .logo {
      width: 140px;
      height: 30px;
    }
  }
  &_left {
    display: flex;
    align-items: center;
  }
  &_right {
    display: flex;
    align-items: center;
  }
}
</style>
